import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApiClient, useContextMenu, useFetch } from '@marageti/z4-lib';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { User, UserStatus } from '@marageti/z4-sdk/lib/auth';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { TabItem } from '../sub-navigation/types';
import TravelerSecondaryAppbarView from './traveler-sub-navigation-view';
import { getMatchingUser } from '../../utils/auth';

const TRAVELER_LINKS: TabItem[] = [
  {
    label: 'profile',
    to: '',
  },
  {
    label: 'trips',
    to: 'trips',
  },
  {
    label: 'reviews',
    to: 'reviews',
  },
  {
    label: 'tickets',
    to: 'tickets',
  },
];

const TravelerSubNavigationContainer = () => {
  const { travelerId } = useParams();
  const navigate = useNavigate();
  const apiClient = useApiClient();

  const [submissionError, setSubmissionError] = useState<ApiError>();
  const [contextMenuAnchor, setContextMenuAnchor, contextMenuOpen] = useContextMenu();

  const { data: traveler, error: tvError } = useFetch<Traveler>(apiClient.peopleClient.getTraveler, [travelerId], !!travelerId);
  const userInfo = traveler ? getMatchingUser(traveler.email, traveler.userInfo) : undefined;
  const { data: user, error: userError, mutate: mutateUser } = useFetch<User>(apiClient.authClient.getUser, [userInfo?.id], userInfo !== undefined);

  if (userError || submissionError || tvError) {
    const apiError: ApiError = userError || submissionError || tvError;
    if (apiError.code === 401) navigate('/logout');
  }

  const onClickNewStatus = (status: UserStatus) => {
    if (traveler && user) {
      const updatedUser: User = {
        ...user,
        status,
      };
      apiClient.authClient.putUser(user.id, updatedUser)
        .then(async () => {
          await mutateUser();
          setContextMenuAnchor(null);
        })
        .catch(setSubmissionError);
    }
  };

  return (
    <TravelerSecondaryAppbarView
      traveler={traveler}
      user={user}
      tabs={TRAVELER_LINKS}
      contextMenuAnchor={contextMenuAnchor}
      contextMenuOpen={contextMenuOpen}
      onClickNewStatus={onClickNewStatus}
      setContextMenuAnchor={setContextMenuAnchor}
    />
  );
};

export default TravelerSubNavigationContainer;
